import Tabs from 'bootstrap/js/dist/tab';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

function clickNav() {
    const menuItems = document.querySelectorAll('.menu-item--children');
    if (window.innerWidth > 991) {
        menuItems.forEach(item => {
            const menuLink = item.querySelector('.menu-link');
            const bigNav = item.querySelector('.big-nav');
            const body = document.querySelector('body');
            
            menuLink.addEventListener("click", function(event) {
                event.stopPropagation();
                const allMenuLinks = document.querySelectorAll('.menu-link');
                const allBigNavs = document.querySelectorAll('.big-nav');
                
                allMenuLinks.forEach(link => {
                    if (link !== menuLink) {
                        link.classList.remove('active');
                        body.classList.remove('overlay');
                    }
                });
                
                allBigNavs.forEach(nav => {
                    if (nav !== bigNav) {
                        nav.classList.remove('active');
                    }
                });

                // Toggle the active class and overlay on body
                const isBigNavActive = bigNav.classList.contains('active');
                menuLink.classList.toggle('active');
                bigNav.classList.toggle('active');

                if (!isBigNavActive && bigNav.classList.contains('active')) {
                    body.classList.add('overlay');
                } else if (isBigNavActive && !bigNav.classList.contains('active')) {
                    body.classList.remove('overlay');
                }
            });

            const back = item.querySelector('.big-nav__back');
            back.addEventListener("click", function() {
                bigNav.classList.remove('active');
            });
        });

        // Handle clicks outside the big-nav
        document.addEventListener("click", function(event) {
            const allBigNavs = document.querySelectorAll('.big-nav.active');
            const body = document.querySelector('body');
            allBigNavs.forEach(nav => {
                if (!nav.contains(event.target)) {
                    nav.classList.remove('active');
                    body.classList.remove('overlay');
                }
            });
        });
    } else {
        menuItems.forEach(item => {
            const menuLink = item.querySelector('.menu-link');
            const bigNav = item.querySelector('.big-nav');
            
            menuLink.addEventListener("click", function(event) {
                event.stopPropagation();
                const allMenuLinks = document.querySelectorAll('.menu-link');
                const allBigNavs = document.querySelectorAll('.big-nav');
                
                allMenuLinks.forEach(link => {
                    if (link !== menuLink) {
                        link.classList.remove('active');
                    }
                });
                
                allBigNavs.forEach(nav => {
                    if (nav !== bigNav) {
                        nav.classList.remove('active');
                    }
                });

                // Toggle the active class and overlay on body
                const isBigNavActive = bigNav.classList.contains('active');
                menuLink.classList.toggle('active');
                bigNav.classList.toggle('active');
            });

            const back = item.querySelector('.big-nav__back');
            back.addEventListener("click", function() {
                bigNav.classList.remove('active');
            });
        });
    }
}


// GSAP ANIMATION FADE
function fadeUpOnScroll() {
    const fadeUpEl = document.querySelectorAll('.fade-up');
    setTimeout(() => {
        fadeUpEl.forEach((item) => {
            gsap.to(item, {
                y: 0,
                autoAlpha: 1,
                duration: 0.8,
                ease: "ease",
                scrollTrigger: {
                    trigger: item,
                    start: "top-=100px bottom-=15%",
                },
            })
        })
    }, 500);
}

export { gsap, ScrollTrigger, clickNav, fadeUpOnScroll };

// WEB LOADING
window.addEventListener('load', function() {
    const loader = document.querySelector('.preloader-area');
    loader.style.display = 'none';
});